<template>
	<div class="block-item">
		<router-link :to="{path:'/auction',query:{id:node.id}}">
			<div class="image">
				<img :src="$pub.imageUrl+node.image" alt="">
				<div class="name">
					{{node.name}}
				</div>
			</div>
			<div class="start" v-if="node.status == 1">
				起拍价：
				<span>¥{{node.start}}元</span>
			</div>
			<div class="now" v-if="node.status == 2">
				当前价：
				<span>¥{{node.now}}元</span>
				（{{node.number}}次出价）
			</div>
			<div class="evaluated">
				评估价：<span>¥{{node.evaluated}}</span>
			</div>
			<div class="tag" v-if="node.status == 1">
				<div class="tag-item" v-for="(item,index) in node['tag']" :key="index">
					{{item}}
				</div>
			</div>
			<div class="coming" v-if="node.status == 1">
				<div class="word">即将开始</div>
				<div class="timestr">
					<i class="el-icon-alarm-clock"></i>
					<span>
						{{node.day}}
					</span>
					日
					<span>
						{{node.timeStr}}
						后开拍
					</span>
				</div>
			</div>
			<div class="limit" v-if="node.status == 2">
				<div class="word">正在进行</div>
				<div class="timestr">
					<i class="el-icon-alarm-clock"></i>
					<span>
						{{node.day}}
					</span>
					日
					<span>
						{{node.timeStr}}
						后结束
					</span>
				</div>
			</div>
			<div class="grey" v-if="node.status > 2">
				<span v-if="node.status == 3">已结束</span>
				<span v-if="node.status == 4">流拍</span>
			</div>
			<div class="views">
				<div>
					<i class="el-icon-view"></i>
					<span>{{node.view}}</span>
					人围观
				</div>
				<div>
					<i class="el-icon-user"></i>
					<span>{{node.people}}</span>
					人报名
				</div>
			</div>
		</router-link>
	</div>
</template>

<script>
	export default {
		name: 'commodity',
		props: ['node', 'footprint'],
		data() {
			return {};
		},
		methods: {},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.block-item {
		width: 23.5%;
		margin-right: 2%;
		background: @vue-bg-color;
		box-shadow: 0px 0px 10px @vue-border-color;
		margin-bottom: @vue-spacing-col-lg;

		a {
			width: 100%;
			color: @vue-text-color;

			.image {
				width: 100%;
				height: 290px;
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					max-width: 100%;
					max-height: 100%;
				}

				.name {
					width: 100%;
					height: 40px;
					line-height: 40px;
					background: @vue-bg-color-mask;
					position: absolute;
					right: 0px;
					bottom: 0px;
					z-index: 9;
					color: @vue-text-color-inverse;
					font-size: @vue-font-size-sm - 2;
					padding: 0px @vue-spacing-row-sm;
					box-sizing: border-box;
				}
			}
		}

		.start,
		.now,
		.evaluated,
		.limit,
		.grey,
		.coming,
		.views {
			width: 100%;
			box-sizing: border-box;
			height: 35px;
			display: flex;
			align-items: center;
		}

		.start {
			font-size: @vue-font-size-min;
			color: @vue-text-color-grey;
			padding: 0px @vue-spacing-row-sm;

			span {
				font-size: @vue-font-size-sm;
				color: @vue-text-color-green;
				font-weight: bold;
			}
		}

		.now {
			font-size: @vue-font-size-min;
			color: @vue-text-color-grey;
			padding: 0px @vue-spacing-row-sm;

			span {
				font-size: @vue-font-size-sm;
				color: @vue-text-color-red;
				font-weight: bold;
			}
		}

		.evaluated {
			font-size: @vue-font-size-min;
			color: @vue-text-color-grey;
			padding: 0px @vue-spacing-row-sm;

			span {
				color: @vue-text-color;
			}
		}

		.tag {
			width: 100%;
			padding: 0px @vue-spacing-row-sm;
			display: flex;
			flex-wrap: wrap;
			box-sizing: border-box;

			.tag-item {
				padding: 3px 5px;
				border: 1px solid @vue-border-color-red;
				border-radius: 16px;
				font-size: @vue-font-size-min;
				color: @vue-text-color-red;
				margin-right: @vue-spacing-row-sm;
				margin-bottom: @vue-spacing-col-sm;
			}
		}

		.limit,
		.coming {
			justify-content: space-between;
			padding-right: @vue-spacing-row-sm;
			box-sizing: border-box;

			.word {
				padding: 0px 10px;
				border-radius: 0px 18px 18px 0px;
				height: 100%;
				display: flex;
				align-items: center;
				font-size: @vue-font-size-min;
				color: @vue-text-color-inverse;
			}

			.timestr {
				height: 100%;
				display: flex;
				align-items: center;
				font-size: @vue-font-size-min;

				span {
					color: @vue-text-color-red;
				}
			}
		}

		.grey {
			background: #999999;
			color: @vue-text-color-inverse;
			font-size: @vue-font-size-min;
			padding: 0px @vue-spacing-row-sm;
			box-sizing: border-box;
		}

		.coming {
			background: #f1f1f1;

			.word {
				background: @vue-bg-color-dg;
			}
		}

		.limit {
			background: #fdf1f1;

			.word {
				background: @vue-bg-color-red;
			}
		}

		.views {
			justify-content: space-between;
			padding: 0px @vue-spacing-row-sm;
			font-size: @vue-font-size-min;

			span {
				color: @vue-text-color-red;
			}
		}
	}
</style>
